import Intercom from "@intercom/intercom-react-native"
export default Intercom
